    import { Fragment } from "react";
import NetwrokSvg from "./NetworkSvg";
import VerticalBeams from "./VerticalBeams";

const LeftVisual = () => {
  return (
    <Fragment>
      <div className="left-visual-wrapper">

        {/* BACK GLOW */}
        <div className="left-glow"></div>

        {/* NETWORK SVG (background layer) */}
        <div className="network-bg">
          <NetwrokSvg />
        </div>

        {/* BEAMS (front layer) */}
        <div className="beams">
          <VerticalBeams />
        </div>

      </div>
    </Fragment>
  );
};

export default LeftVisual;
